import React from 'react';
import { Box, Typography } from '@mui/material';
import { DESIGN_TOKENS } from '../../../styles/constants';

interface SummaryCardProps {
  title: string;
  primaryValue: string;
  primaryChange: string;
  primaryChangePositive: boolean;
  secondaryValue: string;
  secondaryLabel: string;
  isPlanned?: boolean;
  plannedMessage?: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  primaryValue,
  primaryChange,
  primaryChangePositive,
  secondaryValue,
  secondaryLabel,
  isPlanned = false,
  plannedMessage = 'Not enough data yet',
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '24px',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        flex: 1,
      }}
    >
      {/* Title */}
      <Typography
        sx={{
          fontFamily: DESIGN_TOKENS.typography.fontFamily,
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '22.4px',
          color: '#181818',
        }}
      >
        {title}
      </Typography>

      {/* Main Content Row */}
      <Box
        sx={{
          display: 'flex',
          gap: '24px',
          alignItems: 'flex-start',
        }}
      >
        {/* Primary Metric Section */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
          {isPlanned ? (
            <Typography
              sx={{
                fontFamily: DESIGN_TOKENS.typography.fontFamily,
                fontSize: '16px',
                fontWeight: 400,
                lineHeight: '22.4px',
                letterSpacing: '-0.08px',
                color: '#93989C',
                fontStyle: 'italic',
              }}
            >
              {plannedMessage}
            </Typography>
          ) : (
            <>
              <Typography
                sx={{
                  fontFamily: DESIGN_TOKENS.typography.fontFamily,
                  fontSize: '36px',
                  fontWeight: 700,
                  lineHeight: '43.2px',
                  letterSpacing: '-0.36px',
                  color: '#181818',
                }}
              >
                {primaryValue}
              </Typography>
              <Typography
                sx={{
                  fontFamily: DESIGN_TOKENS.typography.fontFamily,
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '19.6px',
                  letterSpacing: '-0.086px',
                  color: primaryChangePositive ? '#426A53' : '#925B64',
                }}
              >
                {primaryChange}
              </Typography>
            </>
          )}
        </Box>

        {/* Secondary Metric Section */}
        {!isPlanned && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
            <Typography
              sx={{
                fontFamily: DESIGN_TOKENS.typography.fontFamily,
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: '28.8px',
                letterSpacing: '-0.24px',
                color: '#181818',
              }}
            >
              {secondaryValue}
            </Typography>
            <Typography
              sx={{
                fontFamily: DESIGN_TOKENS.typography.fontFamily,
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '19.6px',
                letterSpacing: '-0.086px',
                color: '#93989C',
              }}
            >
              {secondaryLabel}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SummaryCard;
